import request from "@/utils/request";
import qs from "qs";

/**
 * 查询商城列表
 * @param params
 * @returns {*}
 */
export function getMallList(params) {
  return request({
    url: "/merchant/getList",
    method: "get",
    params
  });
}

/**
 * 新增-编辑商城
 * @param params
 * @returns {*}
 */
export function editMall(params) {
  return request.post("/merchant/edit", qs.stringify(params));
}

/**
 * 获取商城APP签名
 * @param params
 * @returns {*}
 */
export function getAppSign(params) {
  return request({
    url: "/merchant/getAppSign",
    method: "get",
    params
  });
}
